import { Section, eType, SectionInitData } from "../../Section";
import { Obstacle, FREE_OBSTACLES, FREE_BONUSES } from "./Obstacle";
import { NodeList } from "../../../../../Utils/Collections/NodeList";
import { TIMER, Gameplay } from "../../../../Gameplay";
import { RND } from "../../../../../Utils/RND";
import { GameWorld } from "../../../GameWorld";
import { Pool } from "../../../../../Utils/Collections/Pool";
import { Node } from "../../../../../Utils/Collections/Node";
import { BasicObstacle } from "../../../Obstacle";
import { Game, SfxSprites, eTextureAsset, eSfxSprite, eAudioAsset, rnd } from "../../../../../Game";
import { BonusManager } from "../../../../Bonuses/BonusManager";
import { Bonus } from "../../../../Bonuses/Bonus";
import { Character } from "../../../../Player/Character";
import { LevelManager } from "../../../../Levels";
import { SoundManager } from "../../../../../Utils/SoundManager";



export class CarouselInitData extends SectionInitData {
    /**
     * (RO) Smer posunu prekazek
     */
    get dir(): number { return this._dir; }
    private _dir: number;

    /**
     * (RO) Velikost bunky s prekazkou
     */
    get fullCellSize(): number { return this._fCellSize; }
    private _fCellSize: number;

    /**
     * (RO) Velikost prazdne bunky
     */
    get emptyCellSize(): number { return this._eCellSize; }
    private _eCellSize: number;

    /**
     * (RO) Min pocet bunek s prekazkou v rade za sebou
     */
    get minFCellsInRow(): number { return this._minFCellsInRow; }
    private _minFCellsInRow: number;

    /**
     * (RO) Max pocet bunek s prekazkou v rade za sebou
     */
    get maxFCellsInRow(): number { return this._maxFCellsInRow; }
    private _maxFCellsInRow: number;

    /**
     * (RO) Min pocet bunek bez prekazky v rade za sebou
     */
    get minECellsInRow(): number { return this._minECellsInRow; }
    private _minECellsInRow: number;

    /**
     * (RO) Max pocet bunek bez prekazky v rade za sebou
     */
    get maxECellsInRow(): number { return this._maxECellsInRow; }
    private _maxECellsInRow: number;

    /**
     * (RO) Prodleva mezi posuny v ms
     */
    get shiftInterval(): number { return this._shiftInterval; }
    private _shiftInterval: number;

    /**
     * (RO) Doba, kterou trva posun v ms
     */
    get shiftLen(): number { return this._shiftSpeed; }
    private _shiftSpeed: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(dir: number, fCellSize: number, minFCellsInRow: number, maxFCellsInRow: number, eCellSize: number, minECellsInRow: number, maxECellsInRow: number, shiftInterval: number, shiftSpeed: number) {
        super(eType.carousel);

        this._dir = dir;

        this._fCellSize = fCellSize;
        this._eCellSize = eCellSize;

        this._minFCellsInRow = minFCellsInRow;
        this._maxFCellsInRow = maxFCellsInRow;
        this._minECellsInRow = minECellsInRow;
        this._maxECellsInRow = maxECellsInRow;

        this._shiftInterval = shiftInterval;
        this._shiftSpeed = shiftSpeed;
    }
}



export const enum eState {
    /**
     * Probiha posun prekazek
     */
    shifting,
    /**
     * Odpocet prodlevy do dalsiho posunu
     */
    shiftDelay,
}



export class CarouselCell {
    /**
     * (RO) Posuvnik, kteremu bunka patri
     */
    get carousel(): Carousel { return this._carousel; }
    private _carousel: Carousel;

    /**
     * (RO) Pozice bunky na ose X
     */
    get pos(): number { return this._pos; }
    private _pos: number;

    /**
     * (RO) Stav bunky. True = bunka obsahuje prekazku
     */
    get state(): boolean { return this._state; }
    private _state: boolean;

    /**
     * Prekazka bunky
     */
    get obstacle(): BasicObstacle { return this._obstacle; }
    set obstacle(obstacle: BasicObstacle) {
        this._state = (obstacle ? true : false);
        this._obstacle = obstacle;
    }
    private _obstacle: BasicObstacle;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(carousel: Carousel, pos: number, state: boolean): CarouselCell {
        this._carousel = carousel;
        this._pos = pos;
        this._state = state;

        return this;
    }
}



export class Carousel extends Section {
    /**
     * (RO) Nastaveni posuvniku
     */
    get settings(): CarouselInitData { return this._settings; }
    private _settings: CarouselInitData;

    /**
     * (RO) Aktualni stav
     */
    get state(): eState { return this._state; }
    private _state: eState;

    /**
     * Ulozeni casu
     */
    private _time: number;

    /**
     * Seznam aktivnich prekazek
     */
    private _actObstacles: NodeList<BasicObstacle>;

    /**
     * Bunky posuvniku. Prvni bunka je bud bunka nejvic vpravo nebo bunka nejvic vlevo (podle smeru pohybu posuvniku)
     */
    private _cells: NodeList<CarouselCell>;

    private _lastProcCellNode: Node<CarouselCell>;

    /**
     * Bunka, ktera je na pozici cesty (po ktere beha hrac)
     */
    private _pathCellNode: Node<CarouselCell>;

    /**
     * Pool s volnymi bunkami
     */
    private _freeCells: Pool<CarouselCell>;

    /**
     * Aktualni hodnota posunu posuvniku. Smer posunu je urcen nastavenim (_settings)
     */
    private _shiftOffset: number;

    /**
     * Hodnota posunu posuvniku pred zahajenim posunu.
     */
    private _shiftStartOffset: number;

    /**
     * Prvni vytvorena entita, ktera slouzi jako sablona pro klonovani
     */
    private static _BELT_CLONE_TEMP_ENTITY: pc.Entity;

    /**
     * Entita s pasem
     */
    private _beltEntity: pc.Entity;

    /**
     * MeshInstance s pasem, u ktere se meni offset textury
     */
    private _beltMesh: pc.MeshInstance;

    /**
     * Vektor pro nastaveni transformace textury pasu
     */
    private _beltTexTransform: Float32Array;

    /**
     * Offset textury pri zahajeni pohybu
     */
    private _beltShiftStartTexOffset: number;

    /**
     * Aktualni offset textury
     */
    private _beltShiftTexOffset: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super("carousel", eType.carousel, true);

        // Prekazky
        this._actObstacles = new NodeList<BasicObstacle>();

        // Bunky
        this._cells = new NodeList<CarouselCell>();
        this._freeCells = new Pool<CarouselCell>(CarouselCell, 5, true);

        // Entita
        let e: pc.Entity;

        if (!Carousel._BELT_CLONE_TEMP_ENTITY) {
            let mat = new pc.StandardMaterial();
            mat.diffuseMap = Game.APP.assets.find(eTextureAsset.conveyorBelt, pc.ASSET_TEXTURE).resource;
            mat.diffuseMapTiling.set(7, 1);
            mat.update();

            e = Carousel._BELT_CLONE_TEMP_ENTITY = new pc.Entity();
            e.addComponent(pc.eCompomentType.model, {
                type: pc.eModelType.plane,
                castShadows: false,
                castShadowsLightmap: false,
                material: mat,
            });
            e.setLocalScale(GameWorld.WORLD_WIDTH, 0.01, 0.5);

            // 3D audio
            SoundManager.createSoundComponent(e, {
                positional: true,
                distanceModel: pc.DISTANCE_LINEAR,
                maxDistance: 2
            });

            SoundManager.addSoundSlot(Carousel._BELT_CLONE_TEMP_ENTITY, eSfxSprite.conveyorBeltMove, SfxSprites[eSfxSprite.conveyorBeltMove], Game.APP.assets.find(eAudioAsset.sfx, pc.eAssetType.audio).id);
        }
        else {
            e = Carousel._BELT_CLONE_TEMP_ENTITY.clone();
            SoundManager.addComponent(e.sound);
        }

        e.setPosition(0, 0, 0);

        this._beltEntity = e;
        this._beltMesh = e.model.meshInstances[0];
        this._beltTexTransform = new Float32Array([GameWorld.WORLD_WIDTH, 1, 0, 0]);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(z: number, initData: SectionInitData): Section {
        let reqObsCnt = LevelManager.INSTANCE.lvlSettings.obstacles.maxSimBoxes;

        FREE_OBSTACLES.forEach((pool: Pool<BasicObstacle>) => {
            if (pool.allocatedItemCnt < reqObsCnt)
                pool.createItems(reqObsCnt - pool.size);
        });

        super.activate(z, initData);

        this._settings = initData as CarouselInitData;
        this._beltEntity.setLocalEulerAngles(0, this._settings.dir < 0 ? 180 : 0, 0);

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    deactivate(): Section {
        this.clearCells();

        return super.deactivate();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._state = eState.shiftDelay;
        this._time = TIMER.time + this._settings.shiftInterval;

        let dir = this._settings.dir;

        // Audio
        this._beltEntity.sound.stop(eSfxSprite.conveyorBeltMove);

        // Resetovat posun posuvniku
        this._shiftOffset = 0;

        // Nastavit prvni bunky
        this.clearCells();

        while (this._shiftOffset < GameWorld.WORLD_WIDTH)
            this._shiftOffset = this.addCellsBlock(this._cells.first);

        // Najit bunku, ktera prvni zasahuje do cesty hrace
        this._cells.every((cell: CarouselCell, cellNode: Node<CarouselCell>): boolean => {
            if ((dir > 0 && this.getCellWorldPos(cell) + this.getCellSize(cell) > GameWorld.PATH_X) || (dir < 0 && this.getCellWorldPos(cell) < GameWorld.PATH_X + GameWorld.PATH_WIDTH)) {
                this._pathCellNode = cellNode;
                return false;
            }

            return true;
        });

        // Upravit posun, tak aby bunka byla na stredu cesty
        this._shiftOffset += Math.abs((GameWorld.PATH_X + GameWorld.PATH_WIDTH / 2) - (this.getCellWorldPos(this._pathCellNode.data) + this.getCellSize(this._pathCellNode.data) / 2));

        // Doplnit bunku, pokud posunem chybi na zacatku
        while ((dir > 0 && this.getCellWorldPos(this._cells.first) > 0) || (dir < 0 && this.getCellWorldPos(this._cells.first) + this.getCellSize(this._cells.first) < GameWorld.WORLD_WIDTH)) {
            this.addCellsBlock(this._cells.first);
        }

        // Vytvorit prekazky pro plne bunky
        this._cells.forEach((cell: CarouselCell) => {
            if (cell.state)
                this.actObstacle(cell);
        });

        this._lastProcCellNode = this._cells.firstNode;

        // Posun textury pasu
        this._beltShiftTexOffset = 0;
        this._beltTexTransform[2] = 0;
        this._beltMesh.setParameter("texture_diffuseMapTransform", this._beltTexTransform);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        let stopCarousel = false;

        if (this._state == eState.shiftDelay) {
            if (TIMER.time >= this._time) {
                this._time = TIMER.time;
                this._state = eState.shifting;

                this._shiftStartOffset = this._shiftOffset;
                this._beltShiftStartTexOffset = this._beltShiftTexOffset;

                SoundManager.playSound(this._beltEntity, eSfxSprite.conveyorBeltMove);
            }
        }
        else {
            // Vypocitat aktualni posun pasu
            let progress = (TIMER.time - this._time) / this._settings.shiftLen;

            if (progress > 1) {
                progress = 1;
                stopCarousel = true;
            }

            progress = pc.CubicOut(progress);

            let shiftLen = this.getCellSize(this._pathCellNode.data);

            this._shiftOffset = this._shiftStartOffset + shiftLen * progress;

            let dir = this._settings.dir;
            let cell = this._cells.first;

            while ((dir > 0 && this.getCellWorldPos(cell) > 0) || (dir < 0 && this.getCellWorldPos(cell) + this.getCellSize(cell) < GameWorld.WORLD_WIDTH)) {
                // Pridat blok bunek
                this.addCellsBlock(cell);
                cell = this._cells.first;
            }

            cell = this._lastProcCellNode.data;

            while ((dir > 0 && this.getCellWorldPos(cell) > 0) || (dir < 0 && this.getCellWorldPos(cell) + this.getCellSize(cell) < GameWorld.WORLD_WIDTH)) {
                // Zpracovat dalsi bunku
                this._lastProcCellNode = this._lastProcCellNode.prev;
                cell = this._lastProcCellNode.data;

                if (cell.state) {
                    this.actObstacle(cell);
                }
                else {
                    let bonus = BonusManager.instance.getBonusToThrow(this);

                    if (bonus)
                        this.actBonus(cell, bonus);
                }
            }

            // Posun textury pasu
            this._beltShiftTexOffset = this._beltShiftStartTexOffset + shiftLen * progress;
            this._beltTexTransform[2] = /*this._settings.dir > 0 ?*/ 1 - this._beltShiftTexOffset;// : this._beltShiftTexOffset;
            this._beltMesh.setParameter("texture_diffuseMapTransform", this._beltTexTransform);
        }

        // Aktualizovat prekazky
        this._actObstacles.forEach((obs: Obstacle, node: Node<Obstacle>) => {
            if (!obs.update())
                this._actObstacles.removeByNode(node);
        });

        if (stopCarousel) {
            this._state = eState.shiftDelay;
            this._time = TIMER.time + this._settings.shiftInterval;

            // Nastavit uzel s novou bunkou zasahujici do cesty
            this._pathCellNode = this._pathCellNode.prev;

            // Audio
            this._beltEntity.sound.stop(eSfxSprite.conveyorBeltMove);
        }
    }

    //-------------------------------------------------------------------------
    /**
     * 
     * @param plChar Overit kolize s postavou hrace
     */
    //-------------------------------------------------------------------------
    checkPlCollisions(plChar: Character): void {
        // Detekovat kolizi prekazek s hracem
        let plRc = plChar.collisionRect;
        let secY = this.top;

        let cellNode = this._pathCellNode;
        let cellCnt = (this._state == eState.shiftDelay ? 1 : 2);

        while (cellCnt-- != 0) {
            let cell = cellNode.data;

            if (cell.obstacle && cell.obstacle.checkCollision) {
                let obsRc = cell.obstacle.colRect;

                if (obsRc.x < plRc.right && obsRc.right > plRc.x) {
                    if (obsRc.y + secY < plRc.bottom && obsRc.bottom + secY > plRc.y) {
                        // Je kolize
                        cell.obstacle.handlePlCollision(plChar);
                        return;
                    }
                }
            }

            cellNode = cellNode.prev;
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci velikost bunky
     * @param cell
     */
    //-------------------------------------------------------------------------
    getCellSize(cell: CarouselCell): number {
        return (cell.state ? this._settings.fullCellSize : this._settings.emptyCellSize);
    }

    //-------------------------------------------------------------------------
    /**
     * Prevede pozici bunky na posuvniku na pozici v hernim svete
     * @param cell
     */
    //-------------------------------------------------------------------------
    getCellWorldPos(cell: CarouselCell): number {
        if (this._settings.dir > 0) {
            return this._shiftOffset - cell.pos;
        }
        else {
            return GameWorld.WORLD_WIDTH - this._shiftOffset + cell.pos;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected addObjectEntities(): void {
        this._beltEntity.enabled = true;
        this._beltEntity.reparent(this._root);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private clearCells(): void {
        // Uvolnit aktivni prekazky
        this._actObstacles.forEach((obstacle: Obstacle) => { obstacle.reset(); });
        this._actObstacles.clear();

        // Uvolnit bunky
        this._cells.forEach((cell: CarouselCell) => { this._freeCells.returnItem(cell); });
        this._cells.clear();
    }

    //-------------------------------------------------------------------------
    /**
     * Aktivace prekazky pro zadanou bunku
     * @param cell
     */
    //-------------------------------------------------------------------------
    private actObstacle(cell: CarouselCell): void {
        let obs = FREE_OBSTACLES[rnd.randomIntIn(0, FREE_OBSTACLES.length - 1)].getItem() as Obstacle;
        //console.log("boxes: " + FREE_OBSTACLES[0].allocatedItemCnt);

        obs.activate(this._root, this._size / 2, this._settings.dir, this.getCellWorldPos(cell) + this.getCellSize(cell) / 2, cell);
        this._actObstacles.add(obs);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private actBonus(cell: CarouselCell, bonus: Bonus): void {
        let obs = FREE_BONUSES[bonus.uid].getItem();

        obs.activate(this._root, this._size / 2, this._settings.dir, this.getCellWorldPos(cell) + this.getCellSize(cell) / 2, cell);
        this._actObstacles.add(obs);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private addCellsBlock(prevCell: CarouselCell): number {
        // Urcit stav bunek noveho bloku
        let cellState: boolean;

        if (!prevCell) {
            cellState = rnd.randomBool();
        }
        else {
            cellState = !this._cells.first.state;
        }

        // Ziskat velikost bunky bloku
        let cellSize = cellState ? this._settings.fullCellSize : this._settings.emptyCellSize;

        // Urcit pocet bunek v bloku
        let cellCnt: number;

        if (cellState) {
            cellCnt = rnd.randomIntIn(this._settings.minFCellsInRow, this._settings.maxFCellsInRow);
        }
        else {
            cellCnt = rnd.randomIntIn(this._settings.minECellsInRow, this._settings.maxECellsInRow);
        }

        // Nastavit jednotlive bunky bloku
        let pos = 0;
        let dir = this._settings.dir;

        if (prevCell) {
            pos = prevCell.pos;

            if (dir < 0)
                pos += this.getCellSize(prevCell);
        }

        while (cellCnt-- != 0) {
            let cell = this._freeCells.getItem();

            if (dir > 0)
                pos += cellSize;

            cell.init(this, pos, cellState);
            this._cells.add(cell, 0);

            if (dir < 0)
                pos += cellSize;
        }

        return pos;
    }
}